import React from 'react';

import { iaRa } from 'lib/helpers/utility';
import { useFormBuilderContext } from 'lib/context/FormBuilder/FormBuilderContext';

import Icon from 'components/shared/Icon/Icon';
import { getAnswerLabel } from 'components/practice/Settings/components/Forms/FormBuilder/lib/helpers';
import questionnaire from 'components/practice/Settings/components/Forms/FormBuilder/lib/questionnaire';

import AnswersBox from './AnswersBox';

const FormDetails = ({ formTypes }) => {
  const { formik } = useFormBuilderContext();

  const formType = iaRa(formTypes)?.find((option) => option?.value === formik.values?.form?.type);
  return (
    <div className="rounded-[10px] bg-white p-[21px]">
      <div className="mb-[21px] flex h-[30px] w-max items-center gap-2 rounded-[34px] bg-primary-50 px-[14px] py-[5px] text-center">
        <p className="text-sm font-500 text-primary-500">Form details</p>
        <Icon icon="edit-3-mono" />
      </div>
      <div>
        <AnswersBox question="Form name" answer={formik?.values?.form?.name} />
        <AnswersBox question="Form type" answer={formType?.label} />
        {formik?.values?.form_details?.create_type === 'clinical_template' ? (
          <AnswersBox
            question={questionnaire?.clinical_template?.existing?.title}
            answer={getAnswerLabel(
              questionnaire?.clinical_template?.existing,
              formik?.values?.form_details?.existing
            )}
          />
        ) : (
          <>
            <AnswersBox
              question={questionnaire?.patient_facing_form?.integrate?.title}
              answer={getAnswerLabel(
                questionnaire?.patient_facing_form?.integrate,
                formik?.values?.form_details?.integrate
              )}
            />

            <AnswersBox
              question={questionnaire?.patient_facing_form?.receive?.title}
              answer={getAnswerLabel(
                questionnaire?.patient_facing_form?.receive,
                formik?.values?.form_details?.receive
              )}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default FormDetails;
